// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__36Q6O","rootSmall":"AddTileButton_rootSmall__3OCCe"};